import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        setUser(data.user);
        // Clear hash from URL
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Kia ora, ${data.user.store_name || data.user.email}`);
        navigate(data.user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center text-slate-500" data-testid="auth-callback">
      Signing you in with Google…
    </div>
  );
}
